import {
  FilterAutocompleteItem,
  FilterDateRangeItem,
  FilterSelectItem,
  FilterTextItem,
  useBoolFilterItem,
  UUID_FILTER,
} from '../../../model/filter';
import { AutocompleteService } from '../../../api/autocomplete.service';
import { EntityQueryKey } from '../../../query/query.keys';
import { useOptions } from '../../../hooks/UseOptions';
import { GenderEnum } from '../../../model';
import { FilterTypeEnum } from '../../../model/filter/enum/filter.type.enum';

export function useFilter() {
  const genderOptions = useOptions(GenderEnum, 'snils:gender.');
  return [
    new FilterDateRangeItem({
      field: 'createDate',
      labelKey: 'common:field.createDate',
    }),
    new FilterDateRangeItem({
      field: 'updateDate',
      labelKey: 'common:field.updateDate',
    }),
    UUID_FILTER,
    new FilterAutocompleteItem({
      field: 'user',
      labelKey: 'snils:field.user',
      fetch: AutocompleteService.fetchFn,
      queryKey: EntityQueryKey.User,
    }),
    new FilterAutocompleteItem({
      field: 'client',
      labelKey: 'snils:field.client',
      fetch: AutocompleteService.fetchFn,
      queryKey: EntityQueryKey.Client,
    }),
    new FilterTextItem({
      field: 'fullName',
      labelKey: 'snils:field.fullName',
    }),
    new FilterTextItem({
      field: 'search',
      labelKey: 'snils:field.number',
    }),
    new FilterTextItem({
      field: 'number',
      labelKey: 'snils:field.numberEq',
    }),
    new FilterDateRangeItem(
      {
        field: 'birthDate',
        labelKey: 'snils:field.birthDate',
      },
      FilterTypeEnum.DATE_RANGE,
    ),
    new FilterSelectItem({
      field: 'gender',
      labelKey: 'snils:field.gender',
      options: genderOptions,
    }),
    useBoolFilterItem({
      field: 'isActive',
      labelKey: 'common:field.isActiveM',
    }),
    useBoolFilterItem({
      field: 'isVerified',
      labelKey: 'common:field.isVerifiedM',
    }),
    useBoolFilterItem(
      {
        field: 'isDeleted',
        labelKey: 'common:field.deletedM',
        nullable: false,
      },
      'false',
    ),
  ];
}
